import { render, staticRenderFns } from "./reiki-bergamote.vue?vue&type=template&id=21f31ac5&"
import script from "./reiki-bergamote.vue?vue&type=script&lang=js&"
export * from "./reiki-bergamote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./reiki-bergamote.vue?vue&type=custom&index=0&blockType=router"
if (typeof block0 === 'function') block0(component)

export default component.exports